import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import type { IConfig } from '@cian/config/shared';
import type { ILogger } from '@cian/logger/shared';

import { ApplicationContext } from 'shared/utils/applicationContext';

import type { IReduxStore } from '../../types/redux';
import type { ICustomContextParams } from '../../types/ICustomContextParams';
import { PageContainer } from '../PageContainer';

export interface IApplicationContext {
  config: IConfig;
  logger: ILogger;
}

export interface IApplicationProps extends IApplicationContext {
  reduxStore: IReduxStore;
  customContext: ICustomContextParams;
}

export const Application: React.FC<IApplicationProps> = props => {
  const { logger, config, reduxStore } = props;

  const context = React.useMemo(
    () => ({
      config,
      logger,
    }),
    [config, logger],
  );

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <Provider store={reduxStore}>
          <PageContainer />
        </Provider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
